import { FLAGS, ENV_PREFIX } from 'FeatureFlagsConfig';
import { isProd, ifProd } from 'Utils/env';

const {
  STAGING_CASH_REDIRECT_URL,
  PROD_CASH_REDIRECT_URL,
  STAGING_PAYMENT_TERM_CONDITION_URL,
  PROD_PAYMENT_TERM_CONDITION_URL,
  STAGING_CONEKTA_CHECKOUT_IFRAME_SCRIPT,
  PROD_CONEKTA_CHECKOUT_IFRAME_SCRIPT,
  STAGING_CONEKTA_CHECKOUT_PUBLIC_KEY,
  PROD_CONEKTA_CHECKOUT_PUBLIC_KEY,
  STAGING_EMAIL_SUPPORT,
  PROD_EMAIL_SUPPORT,
  STAGING_MAXMIND_ACCOUNT_ID,
  PROD_MAXMIND_ACCOUNT_ID,
  PROD_LOG_LEVEL,
  STAGING_LOG_LEVEL,
} = process.env;

let prefixedFlags;
let envPrefix;

const parseFlagValue = val => ['true', true, 1, 'True', 'TRUE'].includes(val);
const getPrefixedName = (name) => {
  if (!envPrefix) {
    const env = ifProd('prod', 'stage');
    envPrefix = ENV_PREFIX[env] ?? 'stage';
  }
  return `${envPrefix}_${name}`;
};
const getFlagsEnvironmentMap = (refresh) => {
  if (refresh || !prefixedFlags) {
    prefixedFlags = Object
      .keys(FLAGS)
      .reduce((allFlags, name) => ({ ...allFlags, [name]: getPrefixedName(name) }), {});
  }
  return prefixedFlags;
};
const getFlagsWithRemote = () => (
  Object
    .entries(FLAGS)
    .filter(([, flag]) => 'remote' in flag)
    .reduce((flags, [flagName, { remote }]) => ({ ...flags, [remote]: flagName }), {})
);

const getCashRedirectURL = () => ifProd(PROD_CASH_REDIRECT_URL, STAGING_CASH_REDIRECT_URL);

const getPaymentTermConditionURL = () => ifProd(
  PROD_PAYMENT_TERM_CONDITION_URL, STAGING_PAYMENT_TERM_CONDITION_URL,
);

const useTestingEnvBanner = () => !isProd();

const getConektaCheckoutIframeScript = () => ifProd(
  PROD_CONEKTA_CHECKOUT_IFRAME_SCRIPT, STAGING_CONEKTA_CHECKOUT_IFRAME_SCRIPT,
);

const getConektaPublicKey = () => ifProd(
  PROD_CONEKTA_CHECKOUT_PUBLIC_KEY, STAGING_CONEKTA_CHECKOUT_PUBLIC_KEY,
);

const getSupportEmail = () => ifProd(PROD_EMAIL_SUPPORT, STAGING_EMAIL_SUPPORT);

const getMaxmindAccountId = () => ifProd(PROD_MAXMIND_ACCOUNT_ID, STAGING_MAXMIND_ACCOUNT_ID);

const getLogLevel = () => Number(ifProd(PROD_LOG_LEVEL, STAGING_LOG_LEVEL));


export {
  getCashRedirectURL,
  getConektaCheckoutIframeScript,
  getConektaPublicKey,
  getMaxmindAccountId,
  getPaymentTermConditionURL,
  getSupportEmail,
  useTestingEnvBanner,
  parseFlagValue,
  getPrefixedName,
  getFlagsEnvironmentMap,
  getFlagsWithRemote,
  getLogLevel,
};

export default parseFlagValue;
